export const TRANSLATION_RESOURCES = {
  en: {
    translation: {
      'portfolio-title': "Igor's Portfolio",
      'language-selection-header-stage': 'Language',
      'language-selection-title':
        'Please select your preferred language from the options below.',
      'soft-skills-selection-header-stage': 'Soft Skills',
      'soft-skills-selection-title':
        'When seeking a front-end developer, what soft skills are you looking for?',
      'hard-skills-selection-header-stage': 'Hard Skills',
      'hard-skills-selection-title':
        'When seeking a front-end developer, which hard skills you are looking for?',
      'result-header-stage': 'Result',
      'result-stage-initial-text':
        "Fortunately, I possess the skills and qualities you're seeking in a developer, making me an ideal fit for your team.",
      'result-role': 'Front-end Developer',
      'about-me-text':
        "Greetings! I'm a Front-end Developer with a fervent dedication to crafting captivating, user-friendly websites. Meticulous attention to detail and a commitment to producing clean, efficient code are hallmarks of my work. My journey in web development is fueled by an insatiable thirst for knowledge and a relentless drive to stay updated about the latest advancements. I love to be part of collaborative environments where I can use my skills to contribute meaningfully and I'm always looking to improve both as a developer and as an individual.",
      'contact-button-text': 'Contact Me',
      'users-affected-title': '55 Million',
      'users-affected-text': 'Users affected by my work',
      'experience-title': '4 Years',
      'experience-text': 'Of Experience in the field',
      'projects-title': '6 Projects',
      'projects-text': 'In which I have participated',
      'skill-section-title': 'My Skills',
      'basic-skill-level': 'Basic',
      'intermediate-skill-level': 'Intermediate',
      'expert-skill-level': 'Expert',
      'projects-section-title': 'Check Out Some of My Projects',
      'next-button-text': 'Next',
      'github-button-text': 'See On Github',
      'coming-soon-projects-text': 'More projects coming soon',
      'contact-modal-title': 'Contact',
      'contact-modal-text':
        "I'm happy that you are interested in contacting me! If you want to send me a message, you can use the following means of communication:",
      'copy-email-toast-text': 'My E-mail was copied to your clipboard!'
    }
  },
  pt: {
    translation: {
      'portfolio-title': 'Portfolio do Igor',
      'language-selection-header-stage': 'Linguagem',
      'language-selection-title':
        'Por favor selecione a linguagem de sua preferência nas opções abaixo.',
      'soft-skills-selection-header-stage': 'Soft Skills',
      'soft-skills-selection-title':
        'Quando você está procurando por um desenvolvedor front-end, quais soft skills você busca?',
      'hard-skills-selection-header-stage': 'Hard Skills',
      'hard-skills-selection-title':
        'Quando você está procurando por um desenvolvedor front-end, quais hard skills você busca?',
      'result-header-stage': 'Resultado',
      'result-stage-initial-text':
        'Felizmente, possuo as habilidades e qualidades que você está buscando em um desenvolvedor, o que me torna a opção ideal para sua equipe.',
      'result-role': 'Desenvolvedor Front-end',
      'about-me-text':
        'Olá! Sou um Desenvolvedor Front-end dedicado em criar websites cativantes e fáceis de usar. Atenção meticulosa aos detalhes e um compromisso em produzir código limpo e eficiente são marcas registradas do meu trabalho. Minha jornada em desenvolvimento web é alimentada por uma sede insaciável por conhecimento e uma enorme determinação em me manter atualizado sobre novas tecnologias e práticas. Adoro fazer parte de ambientes colaborativos onde posso usar minhas habilidades para contribuir de forma significativa e sempre estou buscando evoluir tanto como desenvolvedor quanto como indivíduo.',
      'contact-button-text': 'Entrar em Contato',
      'users-affected-title': '55 Milhões',
      'users-affected-text': 'De usuários atingidos pelo meu trabalho',
      'experience-title': '4 Anos',
      'experience-text': 'De experiência como desenvolvedor',
      'projects-title': '6 Projetos',
      'projects-text': 'Onde participei com meu trabalho',
      'skill-section-title': 'Minhas Habilidades',
      'basic-skill-level': 'Básico',
      'intermediate-skill-level': 'Intermediário',
      'expert-skill-level': 'Especialista',
      'projects-section-title': 'Meus Projetos',
      'next-button-text': 'Próximo',
      'github-button-text': 'Ver No Github',
      'coming-soon-projects-text': 'Mais projetos em breve',
      'contact-modal-title': 'Contato',
      'contact-modal-text':
        'Fico feliz que você está interessado em falar comigo! Para me mandar uma mensagem você pode usar os seguintes meios de comunicação:',
      'copy-email-toast-text':
        'Meu e-mail foi copiado para sua área de transferência!'
    }
  }
}
